import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Layout } from './components/Layout';
import Reset from './components/Reset';
import videoDoor from './assets/videoopendoor.mp4';
import posterDoor from './assets/posterdoor.png';
import i18n from './i18n';

import { authenticationService } from './_services/authentication.service';

class Login_se extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
          videoDoorSrc: ''
        };
      }
    componentDidMount() {
        i18n.changeLanguage('se');
        this.setState({
            videoDoorSrc: videoDoor
        })
      };

    render() {
        return (
            <div className="showcase">
                <video src={this.state.videoDoorSrc} poster={posterDoor} muted playsInline autoPlay></video>
                <Layout><div className="text"  style={{color: "white"}}>
                <br/>
                <h2>Logga in</h2>
                <Formik
                    initialValues={{
                        email: '',
                        password: ''
                    }}
                    validationSchema={Yup.object().shape({
                        email: Yup.string().required('Email saknas'),
                        password: Yup.string().required('Lösenord saknas')
                    })}
                    onSubmit={({ email, password }, { setStatus, setSubmitting }) => {
                        setStatus();
                        authenticationService.login(email, password)
                            .then(
                                user => {
                                    
                                    const { from } = this.props.location.state || { from: { pathname: "/editonebonus/new" } };
                                    this.props.history.push(from); 
                                },
                                error => {
                                    
                                    setSubmitting(false);
                                    setStatus('Kombinationen av e-post och lösenord är inkorrekt.');
                                 }
                            );
                    }}>
                    {({ errors, status, touched, isSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="email">E-post</label>
                                <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                <ErrorMessage name="email" component="div" className="invalid-feedback"  style={{color: "white"}}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">Lösenord</label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback"  style={{color: "white"}}/>
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Logga in</button>
                                {isSubmitting &&
                                    <img alt="submitting" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }
                            </div>
                            {status &&
                                <div className={'alert alert-danger'}>{status}</div>
                            }
                        </Form>
                    )}
                </Formik><br /><br />
                <Reset language={'se'} ></Reset><br />
                </div></Layout>
            </div>
        )
    }
}

export { Login_se }; 